// Generated for @nava/participant-copy: Clair's default texts in Dutch. Edit the texts here; the
// participant app's locale files are not read at runtime.
/** Clair's default texts in Dutch. The texts that changed for Clair are translated without native review yet. */
export const PARTICIPANT_COPY_NL = {
    'landing.changeLanguage': 'Taal wijzigen',
    'common.language': 'Taal',
    // New for Clair, translated without native review yet.
    'common.talkInLanguages': 'Je kunt in meer dan 80 talen met Clair praten.',
    'common.seeLanguages': 'Bekijk welke',
    'footer.poweredBy': 'Mogelijk gemaakt door',
    'landing.heading': 'Je bent uitgenodigd voor een kort gesprek.',
    'landing.intro': '{company} hoort graag hoe het bij je gaat. Je praat met Clair, een AI-assistent, wanneer het je uitkomt.',
    'landing.continue': 'Doorgaan',
    'preflight.title': 'We hebben maar een paar dingen nodig',
    'preflight.checkInSubtitle': 'Loop de checklist hieronder door om het gesprek te starten.',
    'preflight.actions.expandItem': '{{item}} uitklappen',
    'preflight.microphone.title': 'Microfoontoegang',
    'preflight.microphone.checkInPrivacy': 'Je stem wordt gebruikt voor het gesprek met Clair, een AI-assistent. Het gesprek wordt opgenomen, getranscribeerd en gedeeld met {company}. Alle gegevens worden versleuteld en veilig opgeslagen.',
    'preflight.microphone.readMore': 'Lees meer',
    'preflight.microphone.grantAccess': 'Toegang verlenen',
    'preflight.microphone.indicatorAction': 'Microfoontoegang verlenen',
    'preflight.microphone.accessGranted': 'Toegang verleend',
    'preflight.microphone.errorHelper': 'Controleer je browserinstellingen en probeer opnieuw.',
    'preflight.microphone.browserNotSupported': 'Je browser ondersteunt geen audio-opname. Gebruik Chrome, Firefox of Safari.',
    'preflight.terms.title': 'Privacy & toestemming',
    'preflight.terms.checkInPrivacy': 'Dit gesprek wordt gevoerd door Clair, een AI-assistent, namens {company}. Je antwoorden worden gedeeld met {company} en nooit gebruikt voor reclame. Je kunt op elk moment stoppen.',
    'preflight.terms.readMore': 'Lees meer',
    'preflight.terms.accept': 'Ja, ik accepteer',
    'preflight.terms.indicatorAction': 'Privacy en toestemming accepteren',
    'preflight.terms.accepted': 'Geaccepteerd',
    'preflight.terms.rememberConsent': 'Mijn toestemming 30 dagen onthouden',
    'preflight.terms.rememberConsentCallTooltip': 'Toestemming wordt alleen voor dit gesprek, in deze browser, 30 dagen bewaard.',
    'quickStart.agree': 'Akkoord',
    'quickStart.back': 'Terug',
    'quickStart.cancel': 'Annuleren',
    'preflight.startCheckIn': 'Start het gesprek',
    'preflight.preparingCheckIn': 'Het gesprek wordt voorbereid...',
    'preflight.preparingCheckInDelayedTitle': 'Het gesprek wordt voorbereid.',
    'preflight.preparingCheckInDelayedSubtitle': 'We zijn nog bezig, even geduld.',
    'preflight.preparingCheckInLongSubtitleLineOne': 'Dit duurt langer dan verwacht.',
    'preflight.preparingCheckInLongSubtitleLineTwo': 'Heb nog even geduld.',
    'preflight.checkInPreparationFailedTitle': 'Het gesprek kon niet worden voorbereid',
    'preflight.checkInPreparationFailedMessage': 'Sommige bestanden voor het gesprek konden niet worden geladen. Controleer je verbinding en probeer het opnieuw.',
    'preflight.retryPreparation': 'Try again',
    'interview.status.connecting': 'Verbinden',
    'interview.status.speaking': 'Spreekt',
    'interview.status.listening': 'Luistert',
    'interview.status.thinking': 'Denkt na',
    'interview.question': 'Vraag {{current}} van {{total}}',
    'interview.mainQuestion': 'Hoofdvraag {{current}} van {{total}}',
    'interview.recording': 'Je antwoord wordt opgenomen...',
    'interview.endInterview': 'Gesprek beëindigen',
    'interview.muteTooltip': 'Microfoon dempen',
    'interview.unmuteTooltip': 'Microfoon inschakelen',
    'interview.pauseTooltip': 'Pauze nemen',
    'interview.resumeTooltip': 'Gesprek hervatten',
    'interview.subtitleTooltip.show': 'Ondertiteling tonen (CC)',
    'interview.subtitleTooltip.hide': 'Ondertiteling verbergen (CC)',
    'interview.toggleChat': 'Typ in plaats daarvan',
    'interview.toggleVoice': 'Spreek in plaats daarvan',
    'interview.chatTooltip.type': 'Typ je antwoord in plaats daarvan',
    'interview.chatTooltip.speak': 'Spreek je antwoord in plaats daarvan',
    'interview.chatTooltip.unavailable': 'Beschikbaar zodra verbonden',
    'interview.chatDiscoveryHint': 'Kun je niet praten? Tik om te typen',
    'interview.chatPlaceholder': 'Typ je bericht...',
    'interview.sendMessage': 'Verzenden',
    'interview.chat.warmHeader': 'Neem je tijd, ik wacht terwijl je typt',
    'interview.chat.newlineHint': 'Shift + Enter voor een nieuwe regel',
    'interview.chat.aiVoiceOn': 'Stem aan',
    'interview.chat.aiVoiceOff': 'Stem uit',
    'interview.chat.backToVoice': 'Terug naar spraak',
    'interview.audio.controls': 'Audio-instellingen',
    'interview.audio.callVolume': 'Gespreksvolume',
    'interview.audio.muteSpeaker': 'Luidspreker dempen',
    'interview.audio.unmuteSpeaker': 'Luidspreker inschakelen',
    'interview.audio.microphone': 'Microfoon',
    'interview.audio.speaker': 'Luidspreker',
    'interview.audio.device': 'Audioapparaat',
    'interview.audio.linkedRouting': 'Je telefoon regelt de microfoon en de luidspreker samen.',
    'interview.audio.phoneSpeaker': 'Luidspreker van de telefoon',
    'interview.audio.phoneEarpiece': 'Oorspeaker van de telefoon',
    'interview.audio.bluetoothHeadset': 'Bluetooth-headset',
    'interview.audio.wiredHeadset': 'Headset met snoer',
    'interview.audio.usbAudio': 'USB-audio',
    'interview.audio.systemDefault': 'Systeemstandaard',
    'interview.audio.changeFailed': 'Kon niet van audioapparaat wisselen.',
    'interview.networkQuality.excellent': 'De netwerkkwaliteit is uitstekend.',
    'interview.networkQuality.good': 'De netwerkkwaliteit is goed.',
    'interview.networkQuality.poor': 'De netwerkkwaliteit is slecht.',
    'interview.networkQuality.bad': 'De netwerkkwaliteit is erg slecht.',
    'interview.networkQuality.offline': 'De verbinding is offline.',
    'interview.pauseModal.title': 'Gesprek gepauzeerd',
    'interview.pauseModal.timeRemaining': 'Nog {{time}}',
    'interview.pauseModal.timeoutWarning': 'Als je gepauzeerd blijft, stopt het gesprek binnenkort vanzelf.',
    'interview.pauseModal.resume': 'Gesprek hervatten',
    'interview.pauseModal.end': 'Gesprek beëindigen',
    'interview.endConfirm.title': 'Het gesprek beëindigen?',
    'interview.endConfirm.body': 'Je kunt niet terugkeren na beëindiging. Je voortgang tot nu toe wordt opgeslagen.',
    'interview.endConfirm.cancel': 'Gesprek voortzetten',
    'interview.endConfirm.end': 'Gesprek beëindigen',
    'complete.checkInTitle': 'Bedankt voor je tijd',
    'complete.checkInMessage': 'Je antwoorden gaan naar het team van {company}.',
    'studyClosed.checkInTitle': 'Dit gesprek is gesloten',
    'studyClosed.checkInMessage': 'Bedankt voor je interesse, het neemt geen antwoorden meer aan.',
    'studyNotOpen.checkInTitle': 'Dit gesprek is nog niet open',
    'studyNotOpen.checkInMessage': 'Probeer de link later nog eens.',
    'studyNotReady.checkInTitle': 'Dit gesprek is bijna klaar',
    'studyNotReady.checkInMessage': 'Probeer de link over een paar minuten nog eens.',
    'participantLinkCompleted.checkInTitle': 'Je hebt dit gesprek al gevoerd',
    'participantLinkCompleted.checkInMessage': 'Bedankt voor je tijd, je hoeft verder niets te doen.',
    'loading.interview': 'Het gesprek wordt geladen...',
    'browserHelp.title': 'Open in je browser',
    'browserHelp.description': 'De ingebouwde browser van deze app kan microfoontoegang beperken. Open deze link in {{browserOptions}} voor de beste ervaring.',
    'browserHelp.namedDescription': 'De ingebouwde browser van {{app}} kan microfoontoegang beperken. Open deze link in {{browserOptions}} voor de beste ervaring.',
    'browserHelp.appleBrowsers': 'Safari of Chrome',
    'browserHelp.windowsBrowsers': 'Microsoft Edge of Chrome',
    'browserHelp.otherBrowsers': 'Chrome of een andere browser',
    'browserHelp.openSafari': 'Open in Safari',
    'browserHelp.copyLink': 'Link kopiëren',
    'browserHelp.copied': 'Link gekopieerd. Plak deze in je browser.',
    'browserHelp.manualCopy': 'Automatisch kopiëren is niet gelukt. Selecteer en kopieer de onderstaande link.',
    'browserHelp.copyInstructions': 'Kopieer de onderstaande link en plak deze in een andere browser. Je kunt ook in het menu van de app zoeken naar een optie om deze pagina in je standaardbrowser te openen.',
    'browserHelp.linkLabel': 'Link naar het gesprek',
    'browserHelp.continueAnyway': 'Toch doorgaan',
    'preflight.microphone.recovery.denied': 'Toegang tot de microfoon geweigerd.',
    'preflight.microphone.recovery.timedOut': 'Het verzoek om microfoontoegang duurde te lang. Controleer of je browser om toestemming vraagt en probeer het opnieuw.',
    'preflight.microphone.recovery.notFound': 'Er is geen microfoon gevonden. Sluit een microfoon aan en probeer het opnieuw.',
    'preflight.microphone.recovery.notReadable': 'Je microfoon kon niet worden ingeschakeld. Sluit andere apps die hem gebruiken en probeer het opnieuw.',
    'preflight.microphone.recovery.failed': 'We konden je microfoon niet gebruiken. Controleer je microfoon en probeer het opnieuw.',
    'preflight.microphone.recovery.retry': 'Opnieuw proberen',
    'preflight.microphone.recovery.close': 'Sluiten',
    'preflight.microphone.recovery.helpTitle': 'Microfoontoegang toestaan',
    'preflight.microphone.recovery.helpDescription': 'Toegang tot de microfoon is nog steeds geblokkeerd. Je browser onthoudt mogelijk je eerdere keuze en vraagt daarom niet opnieuw om toestemming.',
    'preflight.microphone.recovery.safariMacSettings': 'Kies in de menubalk van Safari Safari > Instellingen > Websites > Microfoon. Zoek deze website in de lijst.',
    'preflight.microphone.recovery.chromiumSettings': 'Klik op het pictogram voor site-instellingen links van de adresbalk en kies Site-instellingen > Microfoon.',
    'preflight.microphone.recovery.siteSettings': 'Open de toestemmingen voor deze website via het pictogram of menu naast de adresbalk, of via de site-instellingen van je browser.',
    'preflight.microphone.recovery.allowMicrophone': 'Sta microfoontoegang toe voor deze website, ga terug naar deze pagina en kies ‘Opnieuw proberen’. Laad de pagina opnieuw als je browser daarom vraagt.',
    'preflight.microphone.recovery.deviceSettings': 'Als toegang al is toegestaan, controleer dan in de apparaatinstellingen of deze browser de microfoon mag gebruiken.',
    'microphoneQuality.title': 'Microfoonkwaliteit',
    'microphoneQuality.instructions': 'Spreek een paar seconden zodat we kunnen controleren hoe goed we je kunnen horen.',
    'microphoneQuality.recoveryMessage': 'We kunnen je niet horen. Als je aan het bellen bent, beëindig dan eerst het gesprek. Sluit andere apps die je microfoon gebruiken en probeer het opnieuw.',
    'microphoneQuality.poor': 'Slecht',
    'microphoneQuality.almostThere': 'Bijna daar',
    'microphoneQuality.perfect': 'Perfect!',
    'microphoneQuality.waiting': 'Wachten op audio...',
    'microphoneQuality.from': 'Van',
    'microphoneQuality.defaultDevice': 'Standaardmicrofoon',
    'microphoneQuality.helpText': 'Spreek alsjeblieft harder of ga dichter bij je microfoon staan',
    'microphoneQuality.done': 'Klaar',
    'startupRecovery.title': 'Het gesprek kon niet starten',
    'startupRecovery.failed': 'We konden geen verbinding maken met de gespreksdienst. Probeer het opnieuw.',
    'startupRecovery.timedOut': 'Verbinding maken duurde te lang. Probeer het opnieuw.',
    'startupRecovery.cancelled': 'De verbinding is geannuleerd. Je kunt het opnieuw proberen wanneer je klaar bent.',
    'startupRecovery.microphone': 'We konden je microfoon niet gebruiken. Controleer de toestemmingen en probeer het opnieuw.',
    'startupRecovery.delayed': 'Nog steeds aan het verbinden. Dit duurt langer dan normaal…',
    'startupRecovery.retry': 'Opnieuw proberen',
    'startupRecovery.support': 'Supportreferentie',
    'startupRecovery.copy': 'Referentie kopiëren',
    'startupRecovery.copied': 'Gekopieerd',
    'startupRecovery.checking': 'Verbinding controleren…',
    'startupRecovery.unavailable': 'Niet bevestigd',
    'startupRecovery.advice': 'Deze controle test alleen de bereikbaarheid. Je kunt nog steeds proberen te starten. Lukt dat niet, probeer dan een andere browser of een ander netwerk.',
    'startupRecovery.checkAgain': 'Verbinding opnieuw controleren...',
    'connectionDetails.quality': 'Netwerkkwaliteit',
    'connectionDetails.excellent': 'Uitstekend',
    'connectionDetails.good': 'Goed',
    'connectionDetails.poor': 'Zwak',
    'connectionDetails.bad': 'Slecht',
    'connectionDetails.offline': 'Offline',
    'connectionDetails.notChecked': 'Niet gecontroleerd',
    'connectionDetails.lastChecked': 'Laatst gecontroleerd',
    'connectionDetails.warning': 'De verbinding met {{services}} kon niet worden bevestigd.',
    'connectionDetails.navaApi': 'Clair-API',
    'connectionDetails.interviewApi': 'Gespreksdienst van Clair',
    'connectionDetails.ok': 'OK',
    'connectionDetails.refresh': 'Verbindingstest vernieuwen',
    'connectionDetails.success': 'Verbindingscontrole geslaagd.',
    'connection.error': 'Verbindingsfout',
    'connection.errorDefault': 'Kan geen verbinding maken met de gespreksdienst',
    'connection.retry': 'Opnieuw proberen',
    'versionRefresh.message': 'Er is een nieuwe versie beschikbaar. Vernieuw je browser wanneer het uitkomt.',
    'versionRefresh.action': 'Vernieuwen',
    'cookies.banner.title': 'We hechten waarde aan je privacy',
    'cookies.banner.message': 'We gebruiken cookies om je ervaring te optimaliseren, productgebruik te begrijpen en relevante marketing te ondersteunen. Kies <bold>“Alles accepteren”</bold> om alle cookies te accepteren, of <bold>“Voorkeuren beheren”</bold> om je instellingen aan te passen.',
    'cookies.banner.privacyPolicy': 'Privacybeleid',
    'cookies.banner.acceptAll': 'Alles accepteren',
    'cookies.banner.managePreferences': 'Voorkeuren beheren',
    'cookies.modal.title': 'Cookie-instellingen',
    'cookies.modal.description': 'Wanneer je Clair bezoekt, kunnen we met cookies en vergelijkbare technologieën gegevens over je opslaan of ophalen. Essentiële cookies zorgen ervoor dat de website werkt. Je kunt optionele voorkeuren op elk moment aanpassen.',
    'cookies.modal.readMore': 'Lees meer in ons',
    'cookies.modal.save': 'Opslaan',
    'cookies.modal.close': 'Cookievoorkeuren sluiten',
    'cookies.modal.essential.title': 'Essentieel',
    'cookies.modal.essential.description': 'Vereist voor basisfunctionaliteit van de website. Essentiële cookies kunnen niet worden uitgeschakeld.',
    'cookies.modal.analytics.title': 'Analyse',
    'cookies.modal.analytics.description': 'Helpt Clair te begrijpen hoe de website presteert, hoe bezoekers ermee omgaan en of er technische problemen kunnen zijn.',
    'invitation.subject': 'Een kort gesprek met {company}',
    'invitation.greeting': 'Hoi {name},',
    'invitation.body': 'We horen graag hoe het bij je gaat.',
    'invitation.aiNotice': 'Je praat met Clair, onze AI-assistent. De meeste mensen vinden het makkelijker om eerlijk te zijn tegen een AI dan tegen een mens, en je kunt het doen wanneer het je uitkomt, op je werk of thuis.',
    'invitation.button': 'Start het gesprek',
    'invitation.fallbackLink': 'Of plak deze link in je browser:',
    'invitation.footer': 'Je krijgt deze mail omdat je klant bent bij {company}. Het gesprek wordt namens hen gevoerd door Clair, een AI-assistent.',
    'invitation.optOut': 'Stuur mij dit niet meer',
    'sms.invite': '{company} nodigt je uit voor een kort gesprek:',
    'sms.stop': 'Sms afmelden:',
};
//# sourceMappingURL=nl.js.map